// 空配列を渡したい場合もあるのでこの処理で間違いではない
export interface GetReserveReceiptRequest {
  collections:
    | {
        id: number
        reservedUserId: string
      }[]
    | undefined
}

export function GetReserveReceiptRequestToJSON(
  value: GetReserveReceiptRequest
): any {
  return {
    collections:
      value.collections?.map(collection => {
        return {
          id: collection.id !== 0 ? collection.id : undefined,
          reserved_user_id:
            collection.reservedUserId !== ''
              ? collection.reservedUserId
              : undefined
        }
      }) ?? undefined
  }
}
